/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Dashboard_Story_ViewsInputs */

const en_seller_dashboard_story_views = /** @type {(inputs: Seller_Dashboard_Story_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story Views`)
};

const es_seller_dashboard_story_views = /** @type {(inputs: Seller_Dashboard_Story_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vistas de Historias`)
};

const fr_seller_dashboard_story_views = /** @type {(inputs: Seller_Dashboard_Story_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vues des Stories`)
};

const de_seller_dashboard_story_views = /** @type {(inputs: Seller_Dashboard_Story_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story-Aufrufe`)
};

const id_seller_dashboard_story_views = /** @type {(inputs: Seller_Dashboard_Story_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tayangan Cerita`)
};

/** @type {(inputs: Seller_Dashboard_Story_ViewsInputs) => LocalizedString} */
const ja_seller_dashboard_story_views = en_seller_dashboard_story_views;

/** @type {(inputs: Seller_Dashboard_Story_ViewsInputs) => LocalizedString} */
const zh_seller_dashboard_story_views = en_seller_dashboard_story_views;

/** @type {(inputs: Seller_Dashboard_Story_ViewsInputs) => LocalizedString} */
const ar_seller_dashboard_story_views = en_seller_dashboard_story_views;

/** @type {(inputs: Seller_Dashboard_Story_ViewsInputs) => LocalizedString} */
const it_seller_dashboard_story_views = en_seller_dashboard_story_views;

/** @type {(inputs: Seller_Dashboard_Story_ViewsInputs) => LocalizedString} */
const ru_seller_dashboard_story_views = en_seller_dashboard_story_views;

/** @type {(inputs: Seller_Dashboard_Story_ViewsInputs) => LocalizedString} */
const pt_seller_dashboard_story_views = en_seller_dashboard_story_views;

/** @type {(inputs: Seller_Dashboard_Story_ViewsInputs) => LocalizedString} */
const ko_seller_dashboard_story_views = en_seller_dashboard_story_views;

/**
* | output |
* | --- |
* | "Story Views" |
*
* @param {Seller_Dashboard_Story_ViewsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_dashboard_story_views = /** @type {((inputs?: Seller_Dashboard_Story_ViewsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Dashboard_Story_ViewsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_dashboard_story_views(inputs)
	if (locale === "es") return es_seller_dashboard_story_views(inputs)
	if (locale === "fr") return fr_seller_dashboard_story_views(inputs)
	if (locale === "de") return de_seller_dashboard_story_views(inputs)
	if (locale === "ja") return ja_seller_dashboard_story_views(inputs)
	if (locale === "zh") return zh_seller_dashboard_story_views(inputs)
	if (locale === "ar") return ar_seller_dashboard_story_views(inputs)
	if (locale === "id") return id_seller_dashboard_story_views(inputs)
	if (locale === "it") return it_seller_dashboard_story_views(inputs)
	if (locale === "ru") return ru_seller_dashboard_story_views(inputs)
	if (locale === "pt") return pt_seller_dashboard_story_views(inputs)
	return ko_seller_dashboard_story_views(inputs)
});